import type { SanityPageBuilderCallToActionCardSection, SanityPageBuilderSection } from "@ouster/shared";
import { CallToActionCardBlockView } from "~/features/blocks/inventory/call-to-action-card";
import { toCraftLink } from "~/features/sanity/link";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderCallToActionCardSection;
  };
};
export function SanityCallToActionCardSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  return <CallToActionCardBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} mode={sectionSettings?.mode || "light"} primaryLink={toCraftLink(sectionContent.primaryLink)} secondaryLink={toCraftLink(sectionContent.secondaryLink)} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={sectionContent.text} theme={sectionSettings?.theme || "white"} />;
}